import { gql } from "@apollo/client";

//Obtiene todos los reportes
export const OBTENER_LISTA_REPORTES = gql`
  query LISTAR_REPORTES {
    obtenerListaReportes {
      reporte
      descripcion
      ruta
    }
  }
`;

export const REPORTESPORDIA = gql`
  query COBROSXDIA($fecha: String) {
    reporteCobrosPorDia(fecha: $fecha) {
      id
      PlazaId
      turno
      fechaTrabajo
      fechaReporte
      PersonaId
      folioIngreso
      totalFolios
      totalPermisos
      tipo
      PersonasModel {
        id
        nombre
        apellidos
      }
      PlazaModel {
        id
        nombre
      }
      UserModel {
        name
      }
      MovimientosModel {
        monto
        comision
        neto
        createdAt
      }
    }
  }
`;

export const REPORTESRANGOFECHA = gql`
  query REPORTE_COBROS_ENTREFECHA(
    $fechaInicio: String
    $fechaFin: String
    $tipo: String
    $PersonaId: String
  ) {
    reportesRangoFechas(
      fechaInicio: $fechaInicio
      fechaFin: $fechaFin
      tipo: $tipo
      PersonaId: $PersonaId
    ) {
      id
      PlazaId
      turno
      fechaTrabajo
      fechaReporte
      PersonaId
      folioIngreso
      totalFolios
      totalPermisos
      tipo
      PersonasModel {
        id
        nombre
        apellidos
      }
      PlazaModel {
        id
        nombre
      }
      UserModel {
        name
      }
      MovimientosModel {
        monto
        comision
        neto
        createdAt
      }
    }
  }
`;

export const REPORTESDELEGADO = gql`
  query REPORTEDELEGADOS($entry: FiltroReporte) {
    reportesDelegados(entry: $entry) {
      id
      PlazaId
      turno
      fechaTrabajo
      fechaReporte
      PersonaId
      PersonasModel {
        id
        nombre
        apellidos
      }
      PlazaModel {
        id
        nombre
      }
      UserModel {
        name
      }
      MovimientosModel {
        monto
        comision
        neto
        createdAt
      }
    }
  }
`;

export const REPORTE_EGRESOS = gql`
  query REPORTE_EGRESOS(
    $fechaInicio: String
    $fechaFin: String
    $CatEgresosId: String
    $detalleEgresoId: String
  ) {
    reporteEgresos(
      fechaInicio: $fechaInicio
      fechaFin: $fechaFin
      CatEgresosId: $CatEgresosId
      detalleEgresoId: $detalleEgresoId
    ) {
      descripcion
      MovimientosModel {
        id
        monto
      }
      fechaEgreso
      CatEgresosModel {
        id
        clave
        descripcion
      }
      detalleCuentasEgresosModel {
        clave
      }
    }
  }
`;

export const GENERAR_BALANCE = gql`
  query GENERAR_BALANCE($fechaInicio: String, $fechaFin: String) {
    generarExcel(fechaInicio: $fechaInicio, fechaFin: $fechaFin) {
      filename
      mimetype
      encoding
      content
    }
  }
`;
